define(['knockout',
    '../../appContext',
    'raw-loader!./dvlogin.html',
    './dvlogin.css'],
function (ko, app, componentTemplate) {
    "use strict";

    var dvLogin = {};

    // These types define the different modes of the login prompt.
    dvLogin.types = {
        firstLogin: "firstLogin",
        afterFirstLogin: "afterFirstLogin",
        changePassword: "changePassword",
        resetPassword: "resetPassword",
        forcePasswordReset: "forcePasswordReset",
        reAuth: "reAuth"
    };

    // View model / bindings.
    function componentViewModel(params) {
        var vm = {};

        // Property bindings for model.
        vm.classObject = params.objModel;
        vm.boundShowProperty = vm.classObject().boundShowProperty;
        vm.boundNameProperty = vm.classObject().boundNameProperty;
        vm.title = vm.classObject().title;
        vm.userID = vm.classObject().userID;
        vm.canEditUserID = vm.classObject().canEditUserID;
        vm.password = vm.classObject().password;
        vm.message = vm.classObject().message;
        vm.rememberMe = vm.classObject().rememberMe;
        vm.cacheCredentials = vm.classObject().cacheCredentials;
        vm.submit = vm.classObject().submit;
        vm.nPassword = vm.classObject().nPassword;
        vm.cnPassword = vm.classObject().cnPassword;
        vm.showLogin = vm.classObject().showLogin;
        vm.showCredentials = vm.classObject().showCredentials;
        vm.showPassword = vm.classObject().showPassword;
        vm.showLoginBtn = vm.classObject().showLoginBtn;
        vm.showChangePassword = vm.classObject().showChangePassword;
        vm.showResetPassword = vm.classObject().showResetPassword;
        vm.showForcePasswordReset = vm.classObject().showForcePasswordReset;
        vm.showReAuth = vm.classObject().showReAuth;
        vm.showUserName = vm.classObject().showUserName;
        vm.showCancel = vm.classObject().showCancel;
        vm.cancel = vm.classObject().cancel;
        vm.submitText = vm.classObject().submitText;
        vm.performPassReset = vm.classObject().performPassReset;
        vm.showEmailInput = vm.classObject().showEmailInput;
        vm.emailInput = vm.classObject().emailInput;
        vm.showCapsLock = vm.classObject().showCapsLock;
        vm.showLoading = vm.classObject().showLoading;
        vm.showContent = vm.classObject().showContent;
        vm.showAuthProviders = vm.classObject().showAuthProviders;
        vm.showOffice365 = vm.classObject().showOffice365;
        vm.oauth = vm.classObject().oauth;

        //Set display message...eg
        vm.displayMessage = vm.classObject().displayMessage;
        vm.showDisplayMessage = vm.classObject().showDisplayMessage;

        //set component for error div and error label...eg
        vm.showErrorMessage = vm.classObject().showErrorMessage;
        vm.errorMessage = vm.classObject().errorMessage;


        //handle enter keys for fields to submit
        //check to see if caps lock is on, if so display warning...TD
        $('#txtPassword, #txtnPassword, #txtcnPassword').keypress(function (event) {
            var char = event.char == null ? String.fromCharCode(event.keyCode) : event.char;

            // Enter key
            if (event.keyCode === 13) {
                // Focus the button first to force a blur on the focused text input to hide the mobile keyboard...AM
                $('#btnSubmit').focus().click();
            }
            else if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122)) {
                // Don't show on p/w reset page
                if (vm.showResetPassword()) {
                    return;
                }

                if (event.shiftKey == false && char == char.toUpperCase() || event.shiftKey == true && char == char.toLowerCase()) {
                    vm.classObject().showCapsLock();
                }
            }

            //TODO: Use this code when getModifierState is finally correctly implemented in Chromium...TD
            // As of 1/19/2016 getModifierState is always returning false no matter what...TD
            //var active = event.originalEvent.getModifierState("CapsLock");
            //if (active != null) {
            //    vm.classObject().showCapsLock(active);
            //}
        });
        $("#txtUserID").keyup(function (event) { if (event.keyCode == 13) { vm.classObject().submit(); } });
        $("#txtEmailInput").keyup(function (event) { if (event.keyCode == 13) { vm.classObject().submit(); } });
        $("#chkRememberMe").keyup(function (event) { if (event.keyCode == 13) { vm.classObject().submit(); } });
        $("#btnSubmit").keyup(function (event) { if (event.keyCode === 13 || event.keyCode === 32) { vm.classObject().submit(); } });
        $("#chkCacheCredentials").keyup(function (event) { if (event.keyCode == 13) { vm.classObject().submit(); } });

        return vm;
    }

    dvLogin.component = {};
    dvLogin.componentName = "";
    dvLogin.component.viewModel = componentViewModel;
    dvLogin.component.template = componentTemplate.default;


    // The login prompt object model
    dvLogin.model = function () {
        var m = {
            oauth(type) {
                return function() {
                    //Get the existing query params before the SSO redirect
                    let queryParams = window.location.href.split('?')[ 1 ] || "";

                    // Persist a private form request through the SSO redirects...AM
                    let privateFormName = window.location.pathname.startsWith('/form/') && decodeURIComponent(window.location.pathname.substr(window.location.pathname.indexOf('/form/') + 6));
                    if (privateFormName) {
                        queryParams += `${(queryParams.length > 0) ? '&' : ''}privateFormName=${privateFormName}`;
                    }

                    // Persist admin access requests through SSO redirects...AM
                    if (window.location.pathname.startsWith('/admin')) {
                        queryParams += `${(queryParams.length > 0) ? '&' : ''}adminAccess=true`;
                    }

                    // Redirect with the query string for the service to detect an oauth request
                    window.location = `${window.location.origin}/oauth/${type}?${queryParams}`;
                }
            }
        };

        //Reset the password and information on the screen...eg
        var reset = function (message) {
            m.unlockInputs();
            m.message(message != null ? message : "");
            m.password("");
            m.nPassword("");
            m.cnPassword("");
            return;
        };

        // Bound Properties
        m.componentName = ko.observable(dvLogin.componentName);
        m.boundShowProperty = ko.observable(false);
        m.boundNameProperty = ko.observable(m.componentName());
        m.title = ko.observable("Sign in to" + app.dv.envName);
        m.userID = ko.observable("");
        m.password = ko.observable("");
        m.message = ko.observable("");
        m.rememberMe = ko.observable(false);
        m.cacheCredentials = ko.observable(false);
        m.nPassword = ko.observable("");
        m.cnPassword = ko.observable("");
        m.showLogin = ko.observable(false);
        m.showCredentials = ko.observable(false);
        m.showPassword = ko.observable(true);
        m.showLoginBtn = ko.observable(false);
        m.showChangePassword = ko.observable(false);
        m.showResetPassword = ko.observable(false);
        m.showForcePasswordReset = ko.observable(false);
        m.showReAuth = ko.observable(false);
        m.showUserName = ko.observable(true);
        m.canEditUserID = ko.observable(true);
        m.submitText = ko.observable("Sign In");
        m.showCancel = ko.observable(false);
        m.showEmailInput = ko.observable(false);
        m.emailInput = ko.observable("");

        // Auth provider properties
        m.showAuthProviders = ko.observable(false);
        m.showOffice365 = ko.observable(false);

        //Set Loading Variable...eg
        m.showLoading = ko.observable(true);
        m.showContent = ko.observable(false);

        //Reset Errors and display messages...eg
        m.displayMessage = ko.observable("");
        m.showDisplayMessage = ko.observable(true);

        m.showErrorMessage = ko.observable(false);
        m.errorMessage = ko.observable("");

        m.showCapsLock = function () {
            app.browser.notifier.showToast('Warning: Caps Lock is on.', 6000);
        };

        var submitCallback = null;
        var loginType = null;

        m.show = function (type, callback, reqID) {

            // Remove the workspace-added CSS class so that the login page is scrollable
            document.body.classList.remove("workspace-added");
            document.documentElement.classList.remove("workspace-added");

            loginType = type;
            reset("");
            //Hide the main loader panel
            $("#main-loaderPanel").hide();
            //Hide and Reset the error message...eg
            m.showErrorMessage(false);
            m.errorMessage("");

            //Set the control positions for type...eg
            m.setControlsForType(type, reqID);

            //Determine the type of function this login screen is supposed to perform...eg
            switch (type) {
                //The user is entering the site for the first time. The login screen should display...eg
                case dvLogin.types.firstLogin:
                    //Only allow the user to automatically login if they are allowed to cache the credentials...eg
                    if (app.dv.cache.session.appContext != null && app.dv.cache.session.appContext.user != null && m.showCredentials()) {
                        // First check if we are wanting to automatically use SSO
                        if (app.dv.cache.session.appContext.user.Definition.clientProperties.stayLoggedInSSOType != null) {
                            //Show Loading...eg
                            m.showContent(false);
                            m.showLoading(true);
                            m.oauth(app.dv.cache.session.appContext.user.Definition.clientProperties.stayLoggedInSSOType)();
                            break;
                        }
                        else {
                            // If we are here, then the user has previously elected to be remembered with normal login, hydrate the user info and align the remember me flag...AL
                            m.userID(app.dv.cache.session.appContext.user.Definition.LoginID);
                            m.rememberMe(true);

                            let currentDate = new Date(),
                                pastExpiration = false,
                                expirationDate = app.dv.cache.session.appContext.user.Definition.clientProperties.expirationDate;
                            if (expirationDate != null && currentDate.compareTo(expirationDate) === 1) {
                                pastExpiration = true;
                                app.dv.cache.session.appContext.user.Definition.clientProperties.stayLoggedIn = false;
                                m.rememberMe(false);
                            }

                            // Now check to see if teh user has also elected to 'stay signed in'...AL
                            if (app.dv.cache.session.appContext.user.Definition.clientProperties.stayLoggedIn && !pastExpiration) {
                                // If we are flagged to stay signed in, then automatically execute the login procedure...AL
                                //... but only if/when the cache is completed loading...WR
                                var loggingIn = false;

                                //Show Loading...eg
                                m.showContent(false);
                                m.showLoading(true);

                                var loginInterval = setInterval(function () {
                                    // this is to ensure we don't try to login in twice or while cache is initializing.
                                    if (loggingIn) {
                                        //User is loggin in. Dont show content, only loading...eg
                                        m.showContent(false);
                                        m.showLoading(true);
                                        return;
                                    }
                                    loggingIn = true;
                                    clearInterval(loginInterval);

                                    setTimeout(function () {
                                        // cache is loaded, do the login.
                                        app.dv.cache.session.authenticateUser({
                                            UserLoginID: m.userID(),
                                            Password: app.dv.cache.session.appContext.user.Definition.PasswordSignature
                                        }, m.rememberMe(), m.cacheCredentials(), function (authResult) {
                                            if (authResult && authResult.isAuthenticated) {
                                                m.setErrorMessage("", false); // clear message in case anything is displaying.
                                                submitCallback(true);
                                                m.showContent(false);
                                                m.showLoading(true);
                                            } else {
                                                // There was an issue with the saved sign-in credentials (or maybe the user has been disabled) - show the control with a message...AL
                                                m.setErrorMessage("The stay signed in feature failed to authenticate", true);
                                                app.dv.cache.session.appContext.user.Definition.clientProperties.stayLoggedIn = false;
                                                m.showContent(true);
                                                m.showLoading(false);
                                            }
                                        });
                                    }, 250);
                                }, 250);

                                // We are skipping the show of this control since we are flagged to stay signed in.
                                // However, if there is an issue with the login procedure, the control will be shown (with a message)...AL
                                break;
                            }
                        }
                    }

                    m.showContent(true);
                    m.showLoading(false);
                    m.setControlsForType(dvLogin.types.firstLogin);
                    break;
            }
            if (callback != null) {
                submitCallback = callback;
            }
        };

        //hide the login view...eg
        m.hide = function () {
            m.boundShowProperty(false);

            // Add the workspace-added class to the body and HTML elements so that the canvas doesn't "bounce" when scrolling
            document.body.classList.add("workspace-added");
            document.documentElement.classList.add("workspace-added");
        };

        // Creating the submit event here so that we have visibility to the callback from the show function (i.e. so we don't have to wire extra events)
        m.submit = function () {
            //Hide and reset the error message...eg
            m.showErrorMessage(false);
            m.errorMessage("");

            //check if controls are disabled...MD
            if (m.locked !== null) {
                if (m.locked == true) {
                    return;
                }
            }
            switch (loginType) {
                case dvLogin.types.afterFirstLogin:
                case dvLogin.types.firstLogin:

                    //****************************************************************************
                    //Make sure the user is not blank
                    if (m.userID() == "") {
                        //Show the user an error message...eg
                        m.setErrorMessage("Oops! The username cannot be blank.",true);
                        m.showLoading(false);
                        m.showContent(true);
                        $("#txtUserID").focus();
                        return;
                    }

                    //Make sure that the password is not blank
                    if (m.password() == "") {
                        //Show the user an error message...eg
                        m.setErrorMessage("Oops! The password cannot be blank.",true);
                        m.showLoading(false);
                        m.showContent(true);
                        $("#txtPassword").focus();
                        return;
                    }


                    m.lockInputs();
                    m.showLoading(true);
                    m.showContent(false);
                    app.dv.cache.session.authenticateUser({
                        UserLoginID: m.userID(),
                        Password: m.password()
                    }, m.rememberMe(), m.cacheCredentials(), function (authResult) {
                        if (authResult.isAuthenticated === true) {
                            // User is authenticated - evaluate the check box for 'remember me' and add / remove the user to local storage respectively.
                            m.message(""); // clear message in case anything is displaying.
                            m.unlockInputs();
                            submitCallback(true);
                        }
                        else {
                            //Show the user an error message...eg
                            m.setErrorMessage(authResult.message, true);
                            m.unlockInputs();
                            m.showLoading(false);
                            m.showContent(true);
                            m.password("");
                            $("#txtPassword").focus();
                        }
                    });
                    break;
                //****************************************************************************
                case dvLogin.types.forcePasswordReset:
                //****************************************************************************
                case dvLogin.types.changePassword:
                    //The user wants to change the password...eg
                    //Make sure the current password field is not blank...eg
                    if (m.password() == "") {
                        m.setErrorMessage("Please enter your current password.",true);
                        $("#txtPassword").focus();
                        return;
                    }
                    //Make sure the new password field is not blank...eg
                    if (m.nPassword() == "") {
                        m.setErrorMessage("Please enter a new password.",true);
                        $("#txtnPassword").focus();
                        return;
                    }

                    //Make sure the confirm password field is not blank...eg
                    if (m.cnPassword() == "") {
                        m.setErrorMessage("Please confirm your new password.",true);
                        $("#txtcnPassword").focus();
                        return;
                    }

                    //make sure the new and current passwords match...eg
                    if (m.nPassword() != m.cnPassword()) {
                        m.setErrorMessage("The new password field does not match the confirm password field. Please try again.",true);
                        reset("")
                        m.canEditUserID(false);
                        return;
                    }

                    //Make sure the new password is not the same as the old password...eg
                    if (m.nPassword() == m.password()) {
                        m.setErrorMessage("You must enter a different password than your current one.",true);
                        reset("");
                        m.canEditUserID(false);
                        return;
                    }

                    //Lock the controls...eg
                    m.lockInputs();

                    let fn = app.dv.actionLibrary.actionStores.dvCore.UserResetAccount.Definition.ExecuteAdHoc;
                    if (fn == null) {
                        app.dv.actionLibrary.executeShowMessage(null, function () {
                            m.setErrorMessage("Unable to get access to change account.", true);
                            reset("");
                            m.canEditUserID(false);
                            return;
                        }, this, 'Unable to find User Reset Account action, Please contact your system administrator.');
                    }
                    var user = app.dv.cache.session.currentUser.User;
                    var exeOptions = {
                        action: app.dv.actionLibrary.actionStores.dvCore.UserResetAccount.Definition,
                        context: {
                            view: { raw: null }
                        },
                        defaultSettings: {
                            paramLoginID: m.userID(),
                            paramFirstName: user.Definition.FirstName,
                            paramLastName: user.Definition.LastName,
                            paramDefaultPassword: m.password(),
                            paramDescription: "User requested password change on " + Date.today().toString("dd-MMM-yyyy"),
                            paramResetPassword: true,
                            paramNewPassword: m.nPassword(),
                            paramForcePasswordChange: false
                        },
                        source: this
                    };
                    fn(exeOptions,
                       function (userResetResult) {
                           m.message("");
                           if (userResetResult.success == true) {
                               submitCallback(true);
                               m.close();
                           }
                           else {
                               m.setErrorMessage("Error: Unable to change your password.", true);
                               reset("");
                               m.canEditUserID(false);
                           }

                       });
                    break;
                //****************************************************************************
                case dvLogin.types.reAuth:
                    //****************************************************************************
                    //The user specified to re-authenticate from an action...eg
                    m.lockInputs();
                    app.dv.cache.session.reauthorize(m.userID(), m.password(), submitCallback);
                    m.close();
                    break;
                //****************************************************************************
                case dvLogin.types.resetPassword:
                    //****************************************************************************
                    //The user specified to reset the password....eg
                    if (m.emailInput() == "") {
                        m.setErrorMessage("Email Address cannot be blank.",true);
                        reset("")
                        $("#txtEmailInput").focus();
                        return;
                    }

                    //Validate that the email address is valid...eg
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (re.test(m.emailInput())==false) {
                        m.setErrorMessage("Please enter a valid email address.",true);
                        reset("")
                        $("#txtEmailInput").focus();
                        return;
                    }
                    m.lockInputs();
                    app.dv.cache.session.resetUserPassword(m.emailInput(), app.dv.envName, function (success, error) {
                        m.show(dvLogin.types.firstLogin, submitCallback);
                        let errMsg ="";
                        if (success === true) {
                            errMsg = "Please check email for reset instructions.";
                        }
                        else if (error != null && typeof error.message === 'string') {
                            errMsg = error.message;
                        }
                        else if (typeof error === 'string') {
                            errMsg = error;
                        }
                        else {
                            errMsg = "Unable to reset password.";
                        }
                        reset("");
                        m.emailInput("");
                        m.setControlsForType(dvLogin.types.firstLogin);
                        m.setErrorMessage(errMsg,true);
                    });
                    break;
                //****************************************************************************
            }

        };

        //The Forgot Password button has been clicked...eg
        m.performPassReset = function () {
            //check if controls are disabled...MD
            if (m.locked !== null) {
                if (m.locked == true) {
                    return;
                }
            }

            loginType = dvLogin.types.resetPassword;
            m.setControlsForType(loginType);
        };

        //Close the login page...eg
        m.close = function () {
            m.unlockInputs();
            m.userID("");
            m.password("");
            m.boundShowProperty(false);

            // Add the workspace-added class to the body and HTML elements so that the canvas doesn't "bounce" when scrolling
            document.body.classList.add("workspace-added");
            document.documentElement.classList.add("workspace-added");
        };

        //function to disable controls to avaoid multiple submissions...MD
        m.lockInputs = function () {
            $("#txtPassword").prop('disabled', true);
            $("#txtnPassword").prop('disabled', true);
            $("#txtcnPassword").prop('disabled', true);
            $("#txtEmailInput").prop('disabled', true);
            $("#btnSubmit").prop('disabled', true);
            $("#btnCancel").prop('disabled', true);
            $("#chkRememberMe").prop('disabled', true);
            $("#chkCacheCredentials").prop('disabled', true);
            m.canEditUserID(false);
            m.locked =  true;
        };

        //function to enable controls to avaoid multiple submissions...MD
        m.unlockInputs = function () {
            $("#txtPassword").prop('disabled', false);
            $("#txtnPassword").prop('disabled', false);
            $("#txtcnPassword").prop('disabled', false);
            $("#txtEmailInput").prop('disabled', false);
            $("#btnSubmit").prop('disabled', false);
            $("#btnCancel").prop('disabled', false);
            $("#chkRememberMe").prop('disabled', false);
            $("#chkCacheCredentials").prop('disabled', false);
            m.canEditUserID(true);
            m.locked = false;

        };

        //Cancel button has been clicked....eg
        m.cancel = function () {
            // This is a password reset so go back to login screen...TD
            if (m.submitText._latestValue == "Submit Email") {
                m.showEmailInput(false);
                loginType = dvLogin.types.firstLogin;

                //Set the login type...EG
                m.setControlsForType(loginType);
            }
            else {
                m.password("");
                m.nPassword("");
                m.cnPassword("");
                submitCallback(false, "Login cancelled. Exiting client.", true);
                m.close();
            }
        };

        //Set the display message visibility/text...eg
        m.setDisplayMessage = function(text, isVisible) {
            m.showDisplayMessage(isVisible);
            m.displayMessage(text);
        };

        //Set the error message text/visibility...eg
        m.setErrorMessage = function(text, isVisible) {
            m.showErrorMessage(isVisible);
            m.errorMessage(text);
        };

        //Set the control position based type of form requested...eg
        m.setControlsForType = function(type, reqID) {
            m.boundShowProperty(true);

            m.unlockInputs();

            //Reset the passwords...eg
            reset("");

            //Hide Error message...eg
            m.setErrorMessage("",false);

            //show the loading image...eg
            m.showLoading(false);
            m.showContent(true);

            switch (type) {
                case dvLogin.types.afterFirstLogin:
                case dvLogin.types.firstLogin:
                    //**************************************************************************************/
                    //Show the Login screen...eg
                    m.showLogin(true);
                    m.showCredentials(app.dv.cache.session.config.canCacheCredentials);
                    m.showUserName(true);
                    m.canEditUserID(true);
                    m.showEmailInput(false);
                    m.showPassword(true);
                    m.showChangePassword(false);
                    m.showResetPassword(false);
                    m.showReAuth(false);
                    m.showForcePasswordReset(false);
                    m.showLoginBtn(true);
                    m.showCancel(false);

                    //Determine which auth providers are enabled to display
                    let providers = app.dv.cache.session.config.AuthProviders,
                        hasOauthProviders = false;
                    for (let provider in providers) {
                        if (providers.hasOwnProperty(provider) && providers[provider] != null) {
                            // This is an enabled auth provider, determine which one and set the related KO flags
                            switch (provider) {
                                case "Office365":
                                    m.showOffice365(true);
                                    hasOauthProviders = true;
                                    break;
                                case "Local":
                                    //TODO: disable local login by default and enable it here
                                    break;
                                default:
                                    console.warn(`Unimplemented Auth Provider: ${provider}`);
                                    break;
                            }
                        }
                    }

                    //TODO: Implement support for SSO on cordova applications...AM
                    m.showAuthProviders(hasOauthProviders && !window.cordova);

                    //Set the display heading message for the login type...eg
                    m.setDisplayMessage("Sign in to " + app.dv.envName, true);

                    //Set the submit button text...eg
                    m.submitText("Sign In");

                    //See if the user id or password should have focus
                    if(m.rememberMe() == true){
                        //set focus to the user id control...eg
                        $("#txtPassword").focus();
                    }
                    else{
                        //set focus to the user id control...eg
                        $("#txtUserID").focus();
                    }

                    break;
                //**************************************************************************************/
                case dvLogin.types.resetPassword:
                    //**************************************************************************************/
                    // prep the form for input of email address for reset instructions.
                    m.showLogin(false);
                    m.showCredentials(false);
                    m.showUserName(false);
                    m.canEditUserID(false);
                    m.showEmailInput(true);
                    m.showPassword(false);
                    m.showChangePassword(false);
                    m.showResetPassword(false);
                    m.showReAuth(false);
                    m.showForcePasswordReset(false);
                    m.showLoginBtn(true);
                    m.showCancel(true);

                    //Set the display heading message for the login type...eg
                    m.setDisplayMessage("Specify your email address", true);

                    //Set the submit button text...eg
                    m.submitText("Submit Email");

                    //Hide Error message...eg
                    m.setErrorMessage("", false);

                    const currUserInputValue = m.userID();
                    if (currUserInputValue != null && currUserInputValue !== "") {
                        // Transfer the current email value in the username input to the password reset email input
                        m.emailInput(currUserInputValue);
                    }

                    //Set Focus to the email input...eg
                    $("#txtEmailInput").focus();

                    return;
                //**************************************************************************************/
                case dvLogin.types.changePassword:
                    //**************************************************************************************/
                    //The system should show the change password information...eg
                    m.showLogin(false);
                    m.showCredentials(false);
                    m.showUserName(true);
                    m.canEditUserID(false);
                    m.showEmailInput(false);
                    m.showPassword(true);
                    m.showChangePassword(true);
                    m.showResetPassword(false);
                    m.showReAuth(false);
                    m.showForcePasswordReset(false);
                    m.showLoginBtn(true);
                    m.showCancel(true);
                    m.userID(app.dv.cache.session.currentUser.User.Definition.LoginID);

                    //Set the display heading message for the login type...eg
                    m.setDisplayMessage("Enter New Password Credentials", true);

                    //Set the submit button text...eg
                    m.submitText("Change Password");

                    //Hide Error message...eg
                    m.setErrorMessage("", false);

                    //Set Focus to the email input...eg
                    $("#txtPassword").focus();

                    return;

                //**************************************************************************************/
                case dvLogin.types.forcePasswordReset:
                    //**************************************************************************************/
                    //The system should show the reset password information...eg
                    m.showLogin(false);
                    m.showCredentials(false);
                    m.showUserName(false);
                    m.canEditUserID(false);
                    m.showEmailInput(false);
                    m.showPassword(true);
                    m.showChangePassword(true);
                    m.showResetPassword(false);
                    m.showReAuth(false);
                    m.showForcePasswordReset(false);
                    m.showLoginBtn(true);
                    m.showCancel(false);

                    //Set the user id...eg
                    m.userID(app.dv.cache.session.currentUser.User.Definition.LoginID);

                    //set the display message...eg
                    m.setDisplayMessage("Enter New Password Credentials", true);

                    //Set the submit button text...eg
                    m.submitText("Change Password");

                    //Hide Error message...eg
                    m.setErrorMessage("", false);

                    //Set Focus to the email input...eg
                    $("#txtPassword").focus();
                    break;
                //**************************************************************************************/
                case dvLogin.types.reAuth:
                    //**************************************************************************************/
                    m.showLogin(false);
                    m.showCredentials(false);
                    m.showUserName(true);
                    m.canEditUserID(false);
                    m.showEmailInput(false);
                    m.showPassword(true);
                    m.showChangePassword(false);
                    m.showResetPassword(false);
                    m.showReAuth(true);
                    m.showForcePasswordReset(false);
                    m.showLoginBtn(true);
                    m.showCancel(true);
                    m.userID(reqID);
                    m.password("");

                    //Set the display heading message for the login type...eg
                    m.setDisplayMessage("Verify Login Credentials", true);

                    //Set the submit button text...eg
                    m.submitText("Authorize");

                    //Hide Error message...eg
                    m.setErrorMessage("", false);

                    //Set Focus to the email input...eg
                    $("#txtPassword").focus();

                    break;
                //**************************************************************************************/
            }
        };

        return m;
    };

    //Register the login component...eg
    dvLogin.register = function () {
        dvLogin.componentName = app.dv.appSpace.id + "-dvlogin";
        if (!ko.components.isRegistered(dvLogin.componentName)) {
            ko.components.register(dvLogin.componentName, dvLogin.component);
        }
    };

    return dvLogin;
});
